"use strict";

var _slicedToArray = require("/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LRUCache = require("lru-cache");

var onigasmH_1 = require("./onigasmH");

var OnigString_1 = require("./OnigString");
/**
 * Allocates space on the heap and copies the string bytes on to it
 * @param str
 * @returns pointer to the first byte's address on heap
 */


function mallocAndWriteString(str) {
  var ptr = onigasmH_1.onigasmH._malloc(str.utf8Bytes.length);

  onigasmH_1.onigasmH.HEAPU8.set(str.utf8Bytes, ptr);
  return ptr;
}

function convertUTF8BytesFromPtrToString(ptr) {
  var chars = [];
  var i = 0;

  while (onigasmH_1.onigasmH.HEAPU8[ptr] !== 0x00) {
    chars[i++] = onigasmH_1.onigasmH.HEAPU8[ptr++];
  }

  return chars.join();
}

var cache = new LRUCache({
  dispose: function dispose(scanner, info) {
    var regexTPtrsPtr = onigasmH_1.onigasmH._malloc(info.regexTPtrs.length);

    onigasmH_1.onigasmH.HEAPU8.set(info.regexTPtrs, regexTPtrsPtr);

    var status = onigasmH_1.onigasmH._disposeCompiledPatterns(regexTPtrsPtr, scanner.patterns.length);

    if (status !== 0) {
      var errMessage = convertUTF8BytesFromPtrToString(onigasmH_1.onigasmH._getLastError());
      throw new Error(errMessage);
    }

    onigasmH_1.onigasmH._free(regexTPtrsPtr);
  },
  max: 1000
});

var OnigScanner = /*#__PURE__*/function () {
  /**
   * Create a new scanner with the given patterns
   * @param patterns  An array of string patterns
   */
  function OnigScanner(patterns) {
    _classCallCheck(this, OnigScanner);

    if (onigasmH_1.onigasmH === null) {
      throw new Error("Onigasm has not been initialized, call loadWASM from 'onigasm' exports before using any other API");
    }

    for (var i = 0; i < patterns.length; i++) {
      var pattern = patterns[i];

      if (typeof pattern !== 'string') {
        throw new TypeError("First parameter to OnigScanner constructor must be array of (pattern) strings");
      }
    }

    this.sources = patterns.slice();
  }

  _createClass(OnigScanner, [{
    key: "patterns",
    get: function get() {
      return this.sources.slice();
    }
    /**
     * Find the next match from a given position
     * @param string The string to search
     * @param startPosition The optional position to start at, defaults to 0
     * @param callback The (error, match) function to call when done, match will null when there is no match
     */

  }, {
    key: "findNextMatch",
    value: function findNextMatch(string, startPosition, callback) {
      if (startPosition == null) {
        startPosition = 0;
      }

      if (typeof startPosition === 'function') {
        callback = startPosition;
        startPosition = 0;
      }

      try {
        var match = this.findNextMatchSync(string, startPosition);
        callback(null, match);
      } catch (error) {
        callback(error);
      }
    }
    /**
     * Find the next match from a given position
     * @param string The string to search
     * @param startPosition The optional position to start at, defaults to 0
     */

  }, {
    key: "findNextMatchSync",
    value: function findNextMatchSync(string, startPosition) {
      if (startPosition == null) {
        startPosition = 0;
      }

      startPosition = this.convertToNumber(startPosition);
      var onigNativeInfo = cache.get(this);
      var status = 0;

      if (!onigNativeInfo) {
        var regexTAddrRecieverPtr = onigasmH_1.onigasmH._malloc(4);

        var regexTPtrs = [];

        for (var i = 0; i < this.sources.length; i++) {
          var pattern = this.sources[i];
          var patternStrPtr = mallocAndWriteString(new OnigString_1.default(pattern));
          status = onigasmH_1.onigasmH._compilePattern(patternStrPtr, regexTAddrRecieverPtr);

          if (status !== 0) {
            var errMessage = convertUTF8BytesFromPtrToString(onigasmH_1.onigasmH._getLastError());
            throw new Error(errMessage);
          }

          var regexTAddress = onigasmH_1.onigasmH.HEAP32[regexTAddrRecieverPtr / 4];
          regexTPtrs.push(regexTAddress);

          onigasmH_1.onigasmH._free(patternStrPtr);
        }

        onigNativeInfo = {
          regexTPtrs: new Uint8Array(Uint32Array.from(regexTPtrs).buffer)
        };

        onigasmH_1.onigasmH._free(regexTAddrRecieverPtr);

        cache.set(this, onigNativeInfo);
      }

      var onigString = string instanceof OnigString_1.default ? string : new OnigString_1.default(this.convertToString(string));
      var strPtr = mallocAndWriteString(onigString);

      var resultInfoReceiverPtr = onigasmH_1.onigasmH._malloc(8);

      var regexTPtrsPtr = onigasmH_1.onigasmH._malloc(onigNativeInfo.regexTPtrs.length);

      onigasmH_1.onigasmH.HEAPU8.set(onigNativeInfo.regexTPtrs, regexTPtrsPtr);
      status = onigasmH_1.onigasmH._findBestMatch( // regex_t **patterns
      regexTPtrsPtr, // int patternCount
      this.sources.length, // UChar *utf8String
      strPtr, // int strLen
      onigString.utf8Bytes.length - 1, // int startOffset
      onigString.convertUtf16OffsetToUtf8(startPosition), // int *resultInfo
      resultInfoReceiverPtr);

      if (status !== 0) {
        var _errMessage = convertUTF8BytesFromPtrToString(onigasmH_1.onigasmH._getLastError());

        throw new Error(_errMessage);
      }

      var _Uint32Array = new Uint32Array(onigasmH_1.onigasmH.HEAPU32.buffer, resultInfoReceiverPtr, 3),
          _Uint32Array2 = _slicedToArray(_Uint32Array, 3),
          // The index of pattern which matched the string at least offset from 0 (start)
      bestPatternIdx = _Uint32Array2[0],
          // Begin address of capture info encoded as pairs
      // like [start, end, start, end, start, end, ...]
      //  - first start-end pair is entire match (index 0 and 1)
      //  - subsequent pairs are capture groups (2, 3 = first capture group, 4, 5 = second capture group and so on)
      encodedResultBeginAddress = _Uint32Array2[1],
          // Length of the [start, end, ...] sequence so we know how much memory to read (will always be 0 or multiple of 2)
      encodedResultLength = _Uint32Array2[2];

      onigasmH_1.onigasmH._free(strPtr);

      onigasmH_1.onigasmH._free(resultInfoReceiverPtr);

      onigasmH_1.onigasmH._free(regexTPtrsPtr);

      if (encodedResultLength > 0) {
        var encodedResult = new Uint32Array(onigasmH_1.onigasmH.HEAPU32.buffer, encodedResultBeginAddress, encodedResultLength);
        var captureIndices = [];
        var _i = 0;
        var captureIdx = 0;

        while (_i < encodedResultLength) {
          var index = captureIdx++;
          var start = encodedResult[_i++];
          var end = encodedResult[_i++];

          if (onigString.hasMultiByteCharacters) {
            start = onigString.convertUtf8OffsetToUtf16(start);
            end = onigString.convertUtf8OffsetToUtf16(end);
          }

          captureIndices.push({
            end: end,
            index: index,
            length: end - start,
            start: start
          });
        }

        onigasmH_1.onigasmH._free(encodedResultBeginAddress);

        return {
          captureIndices: captureIndices,
          index: bestPatternIdx,
          scanner: this
        };
      }

      return null;
    }
  }, {
    key: "convertToString",
    value: function convertToString(value) {
      if (value === undefined) {
        return 'undefined';
      }

      if (value === null) {
        return 'null';
      }

      if (value instanceof OnigString_1.default) {
        return value.content;
      }

      return value.toString();
    }
  }, {
    key: "convertToNumber",
    value: function convertToNumber(value) {
      value = parseInt(value, 10);

      if (!isFinite(value)) {
        value = 0;
      }

      value = Math.max(value, 0);
      return value;
    }
  }]);

  return OnigScanner;
}();

exports.OnigScanner = OnigScanner;
exports.default = OnigScanner;